import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  start: {
    paddingTop: '24px',
    minHeight: '17px',

    [theme.breakpoints.down('md')]: {
      height: 'auto'
    }
  },

  end: {
    height: 12
  }
}))

export default useStyles
